import { Box, Stack, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";

const OrderPanel = ({ filter, setFilter }) => {
  useEffect(() => {
    console.log("Component reload");
  }, []);
  return (
    <Box>
      <Stack direction="column" spacing={1.5}>
        <TextField
          label="Order number"
          value={filter.order_no}
          onChange={(e) => setFilter({ ...filter, order_no: e.target.value })}
          type="text"
        />

        <Stack direction="row" justifyContent="center">
          <Typography>OR</Typography>
        </Stack>
        <TextField
          label="Order number from"
          value={filter.order_no__gt}
          onChange={(e) =>
            setFilter({ ...filter, order_no__gt: e.target.value })
          }
          type="text"
          autoComplete="off"
        />

        <TextField
          label="Order number to"
          value={filter.order_no__lt}
          onChange={(e) =>
            setFilter({ ...filter, order_no__lt: e.target.value })
          }
          type="text"
          autoComplete="off"
        />
      </Stack>
    </Box>
  );
};

export default OrderPanel;
